export async function delayMs(ms: number): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, ms))
}

export async function delaySeconds(seconds: number): Promise<void> {
  await delayMs(seconds * 1000)
}

export async function waitUntilTimePassed(
  startTime: number,
  durationSeconds: number,
): Promise<void> {
  const elapsedMs = Date.now() - startTime
  const remainingSeconds = (durationSeconds * 1000 - elapsedMs) / 1000
  if (remainingSeconds > 0) {
    await delaySeconds(remainingSeconds)
  }
}

export async function delayInfinitely(): Promise<void> {
  await delaySeconds(99999)
}

// export async function awaitNextEmit<T>(obs$: Observable<T>): Promise<T> {
//   return firstValueFrom(obs$.pipe(take(1)))
// }
